<script lang="ts">
export default {
  name: 'DropdownItem'
};
</script>
<script lang="ts" setup>
import type { IconName } from '#components/icons/icon.model';
import { MenuItem } from '@headlessui/vue';
import type { PropType } from 'vue';
import VueFeather from 'vue-feather';
import type { RouteLocationRaw } from 'vue-router';
import { RouterLink } from 'vue-router';

defineProps({
  link: { type: Object as PropType<RouteLocationRaw>, required: false, default: undefined },
  icon: { type: String as PropType<IconName>, required: false, default: undefined },
  disabled: { type: Boolean, required: false, default: false },
  testId: { type: String, required: false, default: undefined }
});

defineEmits<{
  click: [];
}>();
</script>

<template>
  <MenuItem v-slot="{ active }">
    <component
      :is="!!link ? RouterLink : 'button'"
      :class="[
        'block px-3 py-1 space-x-2 text-left text-sm leading-6 whitespace-nowrap text-gray-900 w-full break',
        active ? 'bg-gray-50' : 'cursor-pointer',
        disabled && 'text-opacity-40 pointer-events-none'
      ]"
      :to="link"
      :data-testid="testId"
      :disabled="disabled"
      @click="$emit('click')"
    >
      <VueFeather v-if="icon" :type="icon" size="12" />

      <slot :active="active" />
    </component>
  </MenuItem>
</template>
